<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    viewBox="0 0 85 72"
    :class="[size]"
    xml:space="preserve"
  >
    <g id="Group_7" transform="translate(-4 -4)">
      <g id="Group_6">
        <path
          class="st0"
          d="M54.54 33.94c-7.49-.14-13.39-6.26-13.26-13.64v-6.09C41.15 6.87 47.05.75 54.44.62c7.49.14 13.39 6.26 13.26 13.64v6.07c.11 7.37-5.78 13.47-13.16 13.61zm-.1-27.64c-4.14.08-7.54 3.6-7.47 7.85v6.19c-.08 4.3 3.32 7.82 7.57 7.9 4.15-.08 7.54-3.6 7.46-7.85V14.2c.08-4.3-3.31-7.82-7.56-7.9zM67.7 20.35h.01-.01zM26.86 25.3c-6.33 0-11.48-5.15-11.48-11.48S20.53 2.34 26.86 2.34s11.48 5.15 11.48 11.48S33.19 25.3 26.86 25.3zm0-17.27c-3.19 0-5.79 2.6-5.79 5.79s2.6 5.79 5.79 5.79 5.79-2.6 5.79-5.79-2.6-5.79-5.79-5.79zM6.39 61.57a6.27 6.27 0 0 1-5.05-2.6A6.214 6.214 0 0 1 .25 54.3c.66-3.42 2.06-6.65 4.06-9.4 3.69-5.1 9.15-8.45 15.37-9.44 6.22-.99 12.45.5 17.54 4.19 1.27.92 1.56 2.7.63 3.97a2.835 2.835 0 0 1-3.97.63c-3.87-2.8-8.59-3.93-13.31-3.18s-8.85 3.3-11.66 7.16a17.972 17.972 0 0 0-3.07 7.07c-.02.11.05.25.11.34.06.09.18.2.37.23.02 0 .12.01.14.01H23.4c1.57 0 2.85 1.27 2.85 2.85 0 1.57-1.27 2.85-2.85 2.85H6.48c-.03-.01-.06-.01-.09-.01z"
          transform="translate(4 4)"
        />
        <path
          class="st0"
          d="M30.54 71.94c-.25 0-.52-.02-.79-.05a6.292 6.292 0 0 1-4.19-2.42c-1.03-1.34-1.47-3-1.25-4.67 2.15-14.94 15.12-26.18 30.18-26.18s28.03 11.24 30.17 26.15a6.254 6.254 0 0 1-1.8 5.33 6.27 6.27 0 0 1-4.46 1.84H30.54zM54.49 44.3c-12.25 0-22.8 9.14-24.54 21.27-.04.31.2.63.55.67h47.9c.35 0 .63-.28.63-.63C77.29 53.45 66.74 44.3 54.49 44.3z"
          transform="translate(4 4)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "PeopleIcon",
  props: {
    size: {
      type: String,
      default: "medium",
      validator: function (value) {
        // The value must match one of these strings
        return ["small", "medium", "large", "xxlarge"].includes(value);
      },
    },
  },
};
</script>

<style scoped>
.st0 {
  fill: #619bc4;
}
.small {
  height: 16px;
  width: auto;
}
.medium {
  height: 24px;
  width: auto;
}
.large {
  height: 60px;
  width: auto;
}
.xxlarge {
  height: 84px;
  width: auto;
}
</style>
